import { LoginContext } from '@shared/lib/models/login-context';
import { LoginContextProvider } from '@shared/lib/providers/login-context.provider';
import { LoginTokens } from '@usana/ux/sso-auth';

/**
 * MOCK USING
 * window.webkit = { messageHandlers: { login: { postMessage: (msg) => { console.log('ios mobile login got', msg)}}}}; window.usana = { mobile: { ios: true }};
 */
export class IosLoginContextProvider extends LoginContextProvider {
  constructor() {
    super(true, LoginContext.IOS);
  }

  isProvided(window: Window): boolean {
    return (window as any).usana?.mobile?.ios === true;
  }

  notifyOfLogin(window: Window, tokens: LoginTokens, redirectUri: string): void {
    (window as any).webkit.messageHandlers.login.postMessage(tokens);
  }

  handleExternalRedirect(window: Window, url: string) {
    window.location.assign(url);
  }
}
